export interface UserSignatureResponse {
  secureId: string;
}

export interface IBetaFeatureOptRequest {
  featureFlagKey: string;
  enabled: boolean;
}

export enum FeatureFlag {
  FeatureCloseOKR = "feature-close-okr",
  FeatureUserRoles = "roles-filter-list-employees",
  ModuleBadges = "module-badges",
  ModuleWhiteboards = "module-whiteboards",
  ModuleKpis = "module-kpis",
  ModuleTasks = "module-tasks",
  ModuleGifs = "module-gifs",
  FeatureReorderGoalChildren = "reorder-goal-children",
  ModuleScimAccountSettings = "enable-scim-account-settings",
  RestConnector = "restconnector",
  FeatureWhiteboardVoting = "whiteboard-voting",
  FeatureWhiteboardBasicShapes = "whiteboard-basic-shapes",
  MarketplaceDirectSubmissionOfInsights = "marketplace_direct_submission_of_insights",
  ModuleTags = "module-tags",
  HideReadonlySessions = "navigation.hide-readonly-sessions",
  NewExperienceToggle = "new-experience-toggle",
  NewExperience = "new-experience",
  LockMultiAccount = "lock-multi-account",
  AllSessionsGanntMode = "all-sessions-gantt-mode",
  TeamProfileInlineEditing = "enable-teams-employees-inline-editing",
  FeatureSearchRecentItems = "search-recent-items",
  Italian = "italian",
  ProfilesSeeDetails = "profiles-see-details",
  OKRsShareableURLs = "okrs-shareable-urls",
  EnableTagManagement = "enable-tag-management",
  NestedViewV2 = "nested-view-v2",
  EnableInsightRenderingOptimisations = "enable-insight-rendering-optimisations",
  ChartsInLists = "charts-in-lists",
  FeatureUserAutomations = "user-automations",
  UseIndirectMetricCascadeType = "use-indirect-metric-cascade-type",
  NumberFormatting = "number-formatting",
  ImprovePdfExports = "improve-pdfs-export",
  DesignScoreGrid = "okr-design-score-grid",
  EditDeleteComments = "enable-edit-and-delete-comments",
  ShowTheUserWhoCreated = "show-the-user-who-created",
  OrganizationChartV2 = "organization-chart-v2",
  DefaultCustomSessionPermissions = "default-custom-session-permissions",
  HideExternalTeams = "hide-external-teams",
  FeatureSSOSettings = "sso-settings",
  ReorderKpis = "reorder-kpis",
  PersistInsightboardFilters = "persist-insightboard-filters-per-user",
}
